import React from "react";
import Accordion from "../Accordion/Accordion";
import BagItem from "../BagItem/BagItem";

const ConfirmBag = (props) => {
  return (
    <Accordion
      tabName="Your bag"
      toggle={props.data.isBagOpen}
      accordionId="accordionBag"
      itemCount={props.itemCount}
      classes="bag-tab"
      thisRef={props.accordionBagRef}
      availableBag={props.cart}
      data={props.data}
      currency={props.currency}
      unavailablePreviewCount={props.unavailablePreview}
      preorderPreviewCount={props.preorderPreview}
      // partialPreviewCount={props.partialPreview}
      availablePreviewCount={props.availablePreview}
      // actualUnavailableCount={props.actualUnavailableCount}
      // actualPreorderCount={props.actualPreorderCount}
      // actualPartialCount={props.actualPartialCount}
      // actualAvailableCount={props.actualAvailableCount}
      // totalBagPreview={props.totalBagPreview}
      totalConfirmPreview={props.totalConfirmPreview}
      changed={props.changed}
      discountCode={props.discountCode}
      discountLess={props.discountLess}
    >
      {
        // props.isConfirmApiLoaded
        Array.isArray(props.isConfirmApiLoaded) ? (
          // If - Confirm API has value / User has address
          // Display Confirm API Bag Items
          <div>
            {/* ---------------------- Available ---------------------- */}
            {props.data.confirmAvailable &&
            props.data.confirmAvailable.length ? (
              <div>
                {props.data.confirmAvailable.map((item, index) => (
                  <BagItem
                    bagType="available"
                    key={item.isbn}
                    bookImage={item.imagePath}
                    bookTitle={item.title}
                    bookAuthor={item.author}
                    bookPrice={item.price}
                    bookDiscountedPrice={item.discountedPrice || 0}
                    bookISBN={item.isbn}
                    bookType={item.type}
                    bookSubTotal={
                      item.totalAfterDiscount || item.totalPrice || 0
                    }
                    currency={props.currency}
                    changed={(event) =>
                      props.changeQuantityHandler(
                        event,
                        item.isbn,
                        // item.discountedPrice,
                        item.title,
                        item.price,
                        // "brand",
                        // "category",
                        item.gtm.brand,
                        item.gtm.category,
                        item.subject,
                        item.learningStage,
                        item.qualification,
                        item.series,
                        item.gtm.variant,
                        item.quantity,
                        item.discountedPrice,
                        index
                      )
                    }
                    // counter={item.tempQuantity}
                    counter={item.quantity}
                    openDeleteModal={(event) =>
                      props.isRemoveModalOpen(
                        event,
                        item.isbn,
                        // "confirm",
                        item.title,
                        item.price,
                        // "brand",
                        // "category",
                        item.gtm.brand,
                        item.gtm.category,
                        item.subject,
                        item.learningStage,
                        item.qualification,
                        item.series,
                        item.gtm.variant,
                        item.quantity,
                        item.discountedPrice,
                        index
                      )
                    }
                    discountCode={props.discountCode}
                    // discountLess={props.discountLess}
                  />
                ))}
              </div>
            ) : (
              ""
            )}
            {/* ---------------------- Partial ---------------------- */}
            {props.data.confirmPartial && props.data.confirmPartial.length ? (
              <div>
                <div className="bag-type-wrapper">
                  <span className="bag-type partial">Partially available</span>
                  <span className="sub-text">
                    You will be charged when the item is despatched.
                  </span>
                </div>
                {props.data.confirmPartial.map((item, index) => (
                  <BagItem
                    bagType="partial"
                    key={item.isbn}
                    bookImage={item.imagePath}
                    bookTitle={item.title}
                    bookAuthor={item.author}
                    bookPrice={item.price}
                    bookDiscountedPrice={item.discountedPrice || 0}
                    bookISBN={item.isbn}
                    bookType={item.type}
                    // bookSubTotal={item.totalPrice || 0}
                    bookSubTotal={
                      item.totalAfterDiscount || item.totalPrice || 0
                    }
                    readyQty={item.readyQty}
                    duedQty={item.duedQty}
                    currency={props.currency}
                    changed={(event) =>
                      props.changeQuantityHandler(
                        event,
                        item.isbn,
                        // item.discountedPrice,
                        item.title,
                        item.price,
                        // "brand",
                        // "category",
                        item.gtm.brand,
                        item.gtm.category,
                        item.subject,
                        item.learningStage,
                        item.qualification,
                        item.series,
                        item.gtm.variant,
                        item.quantity,
                        item.discountedPrice,
                        index
                      )
                    }
                    // counter={item.tempQuantity}
                    counter={item.quantity}
                    openDeleteModal={(event) =>
                      props.isRemoveModalOpen(
                        event,
                        item.isbn,
                        // "confirm",
                        item.title,
                        item.price,
                        // "brand",
                        // "category",
                        item.gtm.brand,
                        item.gtm.category,
                        item.subject,
                        item.learningStage,
                        item.qualification,
                        item.series,
                        item.gtm.variant,
                        item.quantity,
                        item.discountedPrice,
                        index
                      )
                    }
                    discountCode={props.discountCode}
                    // discountLess={props.discountLess}
                  />
                ))}
              </div>
            ) : (
              ""
            )}
            {/* ---------------------- Preorder ---------------------- */}
            {props.data.confirmPreorder && props.data.confirmPreorder.length ? (
              <div>
                <div className="bag-type-wrapper">
                  <span className="bag-type pre-order">Pre-order</span>
                  <span className="sub-text">
                    You will be charged when the item is despatched.
                  </span>
                </div>
                {props.data.confirmPreorder.map((item, index) => (
                  <BagItem
                    bagType="preorder"
                    key={item.isbn}
                    bookImage={item.imagePath}
                    bookTitle={item.title}
                    bookAuthor={item.author}
                    bookPrice={item.price}
                    bookDiscountedPrice={item.discountedPrice || 0}
                    bookISBN={item.isbn}
                    bookType={item.type}
                    // bookSubTotal={item.totalPrice || 0}
                    bookSubTotal={
                      item.totalAfterDiscount || item.totalPrice || 0
                    }
                    currency={props.currency}
                    changed={(event) =>
                      props.changeQuantityHandler(
                        event,
                        item.isbn,
                        // item.discountedPrice,
                        item.title,
                        item.price,
                        // "brand",
                        // "category",
                        item.gtm.brand,
                        item.gtm.category,
                        item.subject,
                        item.learningStage,
                        item.qualification,
                        item.series,
                        item.gtm.variant,
                        item.quantity,
                        item.discountedPrice,
                        index
                      )
                    }
                    // counter={item.tempQuantity}
                    counter={item.quantity}
                    openDeleteModal={(event) =>
                      props.isRemoveModalOpen(
                        event,
                        item.isbn,
                        // "confirm",
                        item.title,
                        item.price,
                        // "brand",
                        // "category",
                        item.gtm.brand,
                        item.gtm.category,
                        item.subject,
                        item.learningStage,
                        item.qualification,
                        item.series,
                        item.gtm.variant,
                        item.quantity,
                        item.discountedPrice,
                        index
                      )
                    }
                    discountCode={props.discountCode}
                    // discountLess={props.discountLess}
                  />
                ))}
              </div>
            ) : (
              ""
            )}
            {/* ---------------------- Unavailable ---------------------- */}
            {props.data.confirmUnavailableOnly &&
            props.data.confirmUnavailableOnly.length ? (
              <div>
                <div className="bag-type-wrapper">
                  <span className="bag-type unavailable">Unavailable</span>
                  <span className="sub-text">
                    The following items are no longer available for sale, and
                    have not been included in your bag total.
                  </span>
                </div>
                {props.data.confirmUnavailableOnly.map((item, index) => (
                  <BagItem
                    bagType="unavailable"
                    key={item.isbn}
                    bookImage={item.imagePath}
                    bookTitle={item.title}
                    bookAuthor={item.author}
                    bookPrice={item.price}
                    bookDiscountedPrice={item.discountedPrice || 0}
                    bookISBN={item.isbn}
                    bookType={item.type}
                    // bookSubTotal={item.totalPrice || 0}
                    bookSubTotal={
                      item.totalAfterDiscount || item.totalPrice || 0
                    }
                    currency={props.currency}
                    changed={(event) =>
                      props.changeQuantityHandler(
                        event,
                        item.isbn,
                        // item.discountedPrice,
                        item.title,
                        item.price,
                        // "brand",
                        // "category",
                        item.gtm.brand,
                        item.gtm.category,
                        item.subject,
                        item.learningStage,
                        item.qualification,
                        item.series,
                        item.gtm.variant,
                        item.quantity,
                        item.discountedPrice,
                        index
                      )
                    }
                    // counter={item.tempQuantity}
                    counter={item.quantity}
                    openDeleteModal={(event) =>
                      props.isRemoveModalOpen(
                        event,
                        item.isbn,
                        // "confirm",
                        item.title,
                        item.price,
                        // "brand",
                        // "category",
                        item.gtm.brand,
                        item.gtm.category,
                        item.subject,
                        item.learningStage,
                        item.qualification,
                        item.series,
                        item.gtm.variant,
                        item.quantity,
                        item.discountedPrice,
                        index
                      )
                    }
                    discountCode={props.discountCode}
                    // discountLess={props.discountLess}
                  />
                ))}
              </div>
            ) : (
              ""
            )}
            {/* ---------------------- Market Restricted ---------------------- */}
            {props.data.confirmMarketRestricted &&
            props.data.confirmMarketRestricted.length ? (
              <div>
                <div className="bag-type-wrapper">
                  {props.data.confirmUnavailableOnly &&
                  props.data.confirmUnavailableOnly.length == 0 ? (
                    <span className="bag-type unavailable">Unavailable</span>
                  ) : (
                    // <span className="bag-type market-restricted"></span>
                    ""
                  )}

                  <span className="sub-text">
                    Sorry, these items are not available for purchase online in
                    the country of your chosen shipping address, and has not
                    been included in your bag total. To place an order please
                    contact your local Customer Services team.
                  </span>
                </div>
                {props.data.confirmMarketRestricted.map((item, index) => (
                  <BagItem
                    bagType="unavailable"
                    key={item.isbn}
                    bookImage={item.imagePath}
                    bookTitle={item.title}
                    bookAuthor={item.author}
                    bookPrice={item.price}
                    bookDiscountedPrice={item.discountedPrice || 0}
                    bookISBN={item.isbn}
                    bookType={item.type}
                    // bookSubTotal={item.totalPrice || 0}
                    bookSubTotal={
                      item.totalAfterDiscount || item.totalPrice || 0
                    }
                    currency={props.currency}
                    changed={(event) =>
                      props.changeQuantityHandler(
                        event,
                        item.isbn,
                        // item.discountedPrice,
                        item.title,
                        item.price,
                        // "brand",
                        // "category",
                        item.gtm.brand,
                        item.gtm.category,
                        item.subject,
                        item.learningStage,
                        item.qualification,
                        item.series,
                        item.gtm.variant,
                        item.quantity,
                        item.discountedPrice,
                        index
                      )
                    }
                    // counter={item.tempQuantity}
                    counter={item.quantity}
                    openDeleteModal={(event) =>
                      props.isRemoveModalOpen(
                        event,
                        item.isbn,
                        // "confirm",
                        item.title,
                        item.price,
                        // "brand",
                        // "category",
                        item.gtm.brand,
                        item.gtm.category,
                        item.subject,
                        item.learningStage,
                        item.qualification,
                        item.series,
                        item.gtm.variant,
                        item.quantity,
                        item.discountedPrice,
                        index
                      )
                    }
                    discountCode={props.discountCode}
                    // discountLess={props.discountLess}
                  />
                ))}
              </div>
            ) : (
              ""
            )}
          </div>
        ) : (
          // Else - Confirm API has no value / User has no address
          // Display Bag API
          <div>
            {props.cart.map((item, index) => (
              <BagItem
                bagApi="bag"
                key={item.isbn}
                bookImage={item.imagePath}
                bookTitle={item.title}
                bookAuthor={item.author}
                bookPrice={item.price}
                bookPriceAlerts={(
                  item.price *
                  (1 - props.discountLess)
                ).toFixed(2)}
                // bookDiscountedPrice={item.discountedPrice}
                bookDiscountedPrice={
                  props.discountCode.toUpperCase() == "ALERTSDISCOUNT"
                    ? (item.price * (1 - props.discountLess)).toFixed(2)
                    : item.discountedPrice
                }
                bookISBN={item.isbn}
                bookType={item.type}
                // bookSubTotal={item.tempTotalPrice}
                bookSubTotal={
                  props.discountCode.toUpperCase() == "ALERTSDISCOUNT"
                    ? (
                        Math.round(
                          parseFloat(
                            item.tempTotalPrice.toString().replace(/,/g, "")
                          ) *
                            (1 - props.discountLess) *
                            100
                        ) / 100
                      ).toFixed(2)
                    : item.tempTotalPrice
                }
                currency={props.currency}
                changed={(event) =>
                  props.app.changed(
                    event,
                    item.isbn,
                    item.title,
                    item.price,
                    // "brand",
                    // "category",
                    item.gtm.brand,
                    item.gtm.category,
                    item.subject,
                    item.learningStage,
                    item.qualification,
                    item.series,
                    item.gtm.variant,
                    item.quantity,
                    item.currencyCode,
                    item.discountedPrice,
                    index
                  )
                }
                counter={item.tempQuantity}
                openDeleteModal={(event) =>
                  props.isBagRemoveModalOpen(
                    event,
                    item.isbn,
                    // "confirm",
                    item.title,
                    item.price,
                    // "brand",
                    // "category",
                    item.gtm.brand,
                    item.gtm.category,
                    item.subject,
                    item.learningStage,
                    item.qualification,
                    item.series,
                    item.gtm.variant,
                    item.quantity,
                    item.currencyCode,
                    item.discountedPrice,
                    index
                  )
                }
                // openDeleteModal={(event) =>
                //   props.isRemoveModalOpen(event, item.isbn, "confirm")
                // }
                discountCode={props.discountCode}
                // discountLess={props.discountLess}
              />
            ))}
          </div>
        )
      }
    </Accordion>
  );
};

export default ConfirmBag;
